import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

library.add(fas);

// Faux backend de développement. L'import est dynamique : sans la variable, le module
// n'est jamais chargé et ne pèse rien dans le bundle de production.
if (process.env.REACT_APP_MOCK_API === "true") {
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
  require("./api/mockServer").installMockServer();
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
